
import Vue from 'vue'

import DialogTemplate from '@/_components/dialog/template/template.vue'
const PostModuleBklr = Vue.extend({
    mixins: [],
    components: { DialogTemplate },
})

export default PostModuleBklr
